import { useContext } from 'react';
import { type Context, type ReactNode, createContext } from 'react';

export interface ZendeskLocalization {
  getLocalizedArticle: (articleSlug: string | number) => string;
  getLocalizedCategory: (categorySlug: string | number) => string;
  getLocalizedHelpCenter: string;
  organizationCountry: string;
}

export const ZendeskLocalizationContext: Context<ZendeskLocalization | null> =
  createContext<ZendeskLocalization | null>(null);

export function ZendeskLocalizationProvider({
  zendeskLocalization,
  children,
}: {
  zendeskLocalization: ZendeskLocalization;
  children: ReactNode;
}): JSX.Element {
  return (
    <ZendeskLocalizationContext.Provider value={zendeskLocalization}>
      {children}
    </ZendeskLocalizationContext.Provider>
  );
}

export function useZendeskLocalization(): ZendeskLocalization {
  const context = useContext(ZendeskLocalizationContext);
  if (context === null) {
    throw new Error('useZendeskLocalization must be used within an ZendeskLocalizationProvider');
  }
  return context;
}
